<template>
<div id="hrprofile" class="hrprofile">
	<div class="hrprofile__profile">

		<v-form class="profile__form">
			<div class="form__block-1">

				<!-- ----------- -->
				<!--   PICTURE   -->
				<!-- ----------- -->
				<div class="block-1__picture">
					<img 
						:src="getPictureUrl" 
						@click="$refs.uploadimage.click()"
						v-bind:alt="profile['first name']"
					/>

					<input 
						class="picture__input"
						type="file" 
						ref="uploadimage" 
						@change="previewImage" 
						accept="image/jpg,image/jpeg"
					>
				</div>

				<!-- -------- -->
				<!--   NAME   -->
				<!-- -------- -->
				<div class="block-1__section input-padding">
					<div class="section__row">
						<div class="section__label iomico-style-lable">Name</div>
					</div>

					<v-text-field
						class="row__cell"
						v-model="profile['first name']"
						label="First Name"
					></v-text-field>

					<v-text-field
						class="row__cell"
						v-model="profile['last name']"
						label="Last Name"
					></v-text-field>
				</div>

				<!-- ----------- -->
				<!--   GENERAL   -->
				<!-- ----------- -->
				<div class="block-1__section input-padding">

					<div class="section__row">
						<div class="section__label iomico-style-lable">General</div>
					</div>

					<v-text-field
						class="row__cell"
						prepend-icon="mdi-office-building"
						v-model="profile['employer']"
						label="employer"
					></v-text-field>

					<v-text-field
						class="row__cell"
						prepend-icon="mdi-clipboard-account"
						v-model="profile['position']"
						label="position"
					></v-text-field>

					<v-text-field
						prepend-icon="mdi-cake-variant"
						v-model="profile['birthday']"
						label="age"
					></v-text-field>

					<div class="block-1__row">
						<v-select
							class="row__family-status"
							prepend-icon="mdi-heart-multiple"
							:items="familyStatus"
							v-model="profile['family status']"
							label="family status"
							@change="updateChildren(profile['family status'])"
						></v-select>

						<v-text-field
							type="number"
							class="row__children"
							v-model="profile['children']"
							label="children"
							v-if="profile['family status']=='Married'"
						></v-text-field>
					</div>
				</div>

				<!-- ------------- -->
				<!--   GEOGRAPHY   -->
				<!-- ------------- -->
				<div class="block-1__section input-padding">
					<div class="section__level-1">
						<div class="level-1__row">
							<div class="section__label iomico-style-lable">citizenship</div>
						</div>

						<v-text-field
							prepend-icon="mdi-passport"
							v-model="profile['citizenship']"
							label="citizenship"
						></v-text-field>
					</div>

					<div class="section__level-1">
						<div class="level-1__row">
							<div class="section__label iomico-style-lable">residence</div>
						</div>

						<v-text-field
							prepend-icon="mdi-earth"
							v-model="profile['residence']['country']"
							label="country"
						></v-text-field>

						<v-text-field
							prepend-icon="mdi-map-marker"
							v-model="profile['residence']['city']"
							label="city"
						></v-text-field>

					</div>
				</div>



				<!-- ------------ -->
				<!--   CONTACTS   -->
				<!-- ------------ -->
				<div class="block-1__section input-padding">

					<div class="section__level-1">
						<div class="level-1__row">
							<div class="section__label iomico-style-lable">phone</div>
						</div>

						<v-text-field
							class="level-1__cell"
							prepend-icon="mdi-phone"
							v-model="profile['contacts']['phone']"
							label="phone"
						></v-text-field>
					</div>

					<div class="section__level-1">
						<div class="level-1__row">
							<div class="section__label iomico-style-lable">email</div>
						</div>
						<v-text-field
							class="level-1__cell"
							prepend-icon="mdi-email"
							v-model="profile['contacts']['email personal']"
							label="personal email"
						></v-text-field>

						<v-text-field
							class="level-1__cell"
							prepend-icon="mdi-email-outline"
							v-model="profile['contacts']['email work']"
							label="work email"
						></v-text-field>
					</div>

					<div class="section__level-1">
						<div class="level-1__row">
							<div class="section__label iomico-style-lable">social networks</div>
						</div>

						<v-text-field
							class="level-1__cell"
							prepend-icon="mdi-linkedin"
							v-model="profile['contacts']['linkedin']"
							label="linkedin"
						></v-text-field>
					</div>
				</div>

				<!-- ------------- -->
				<!--   LANGUAGES   -->
				<!-- ------------- -->
				<div class="block-1__section">
					<div class="section__label iomico-style-lable">languages</div>
					
					<div class="section__item"
						v-bind:key="langIndex"
						v-for="(language, langIndex) in profile['languages']"
					>
						<div class="item__order-btns">

							<v-btn 
								v-if="ifMoveUp(langIndex)"
								depressed 
								small
								@click="moveArrElement(profile['languages'], langIndex, (langIndex-1))"
								class="btns__btn up"
							>
								<v-icon right dark>mdi-chevron-up</v-icon>
							</v-btn>

							<v-btn 
								v-if="ifMoveDown(profile['languages'], langIndex)"
								depressed 
								small
								@click="moveArrElement(profile['languages'], langIndex, (langIndex+1))"
								class="btns__btn down"
							>
								<v-icon right dark>mdi-chevron-down</v-icon>
							</v-btn>

							<v-btn 
								depressed 
								small
								@click="removeArrElement(profile['languages'], langIndex)"
								class="btns__btn close"
							>
								<v-icon right dark>mdi-close</v-icon>
							</v-btn>
						</div>

						<v-text-field
							class="item__lang-name extra-shifted-left"
							v-model="language.name"
							label="Language"
						></v-text-field>


						<v-select
							class="item__total-level extra-shifted-left"
							:items="languageLevels"
							v-model="language.total_level"
							label="Level"
						></v-select>

						<div class="item__body">
							<div class="body__rating"
								v-bind:key="levelIndex"
								v-for="(level, levelIndex) in language['levels']">
								
								<Rating 
									class="rating__level"
									v-model="level[1].rate"
									:readonly="true"
									:length="5" />

								<div class="rating__name">{{level[0]}}</div>
							</div>

						</div>
					</div>
					<div class="section__btns">
						<v-btn 
							depressed 
							@click="addLanguage(profile['languages'])"
							class="blue add">
							Add
						</v-btn>
					</div>
				</div>

				<!-- --------- -->
				<!--   HOBBY   -->
				<!-- --------- -->
				<div class="block-1__section input-padding">
					<div class="section__label iomico-style-lable">hobby</div>

					<v-combobox
						v-model="profile.hobby"
						chips
						clearable
						multiple
					>
						<template v-slot:selection="{ attrs, item, select, selected }">
							<v-chip
								close
								small
								label

								v-bind="attrs"
								:input-value="selected"

								@click="select"
								@click:close="removeHobby(profile.hobby, item)"
							>
								<strong>{{ item }}</strong>
							</v-chip>
						</template>
					</v-combobox>
				</div>
			</div>

			<div class="form__block-2">
				<v-btn 
					depressed 
					x-large
					@click="deleteProfile(profile.profile_id)"
					class="block-2__delete-btn red cancel"
				>
					Delete
				</v-btn>

				<div class="block-2__btns">
					<v-btn 
						depressed 
						x-large
						:to="{name: 'profileview', params: { id: profile.profile_id }}" 
						class="btns__btn grey share"
					>
						<v-icon dark>mdi-share-variant</v-icon>
					</v-btn>

					<v-btn 
						depressed 
						x-large
						:to="{name: 'hr'}"
						class="btns__btn grey cancel"
					>
						Cancel
					</v-btn>

					<v-btn 
						depressed 
						x-large
						@click="saveProfile(profile)"
						class="btns__btn blue save"
					>
						Save
					</v-btn>
				</div>

				<div class="block-2__controls-wrapper">

					<!-- ------------ -->
					<!--   CONTROLS   -->
					<!-- ------------ -->
					<div class="controls-wrapper__controls">

						<div 
							@click="updateActiveFromTab('expertise')"
							class="controls__btn expertise"
							:class="{active: activeFromTab == 'expertise'}"
						>
							expertise
						</div>

						<div 
							@click="updateActiveFromTab('work')"
							class="controls__btn work"
							:class="{active: activeFromTab == 'work'}"
						>
							work
						</div>

						<div 
							@click="updateActiveFromTab('education')"
							class="controls__btn education"
							:class="{active: activeFromTab == 'education'}"
						>
							education
						</div>

					</div>
				</div>


				<!-- ------------- -->
				<!--               -->
				<!--   EXPERTISE   -->
				<!--               -->
				<!-- ------------- -->
				<div 
					v-if="activeFromTab == 'expertise'"
					class="block-2__level-1 expertise"
				>
					<div
						class="level-1__level-2"
					>
						<div class="level-2__title iomico-style-lable">
							about
						</div>

						<v-textarea
							name="about"
							v-model="profile['about']"
							hide-details="true"
							label="About"
							value=""
						></v-textarea>
					</div>

					<div
						class="level-1__level-2"
						v-bind:key="expertiseName"
						v-for="(subExpertises, expertiseName) in profile['expertise']"
					>
						<div class="level-2__title iomico-style-lable">
							{{expertiseName}}
						</div>

						<div class="level-2__level-3">
							<div 
								class="level-3__items"
								v-bind:key="subExpertiseName"
								v-for="(subExpertise, subExpertiseName) in subExpertises"
							>
								<div class="items__label">
									<div class="label__text">{{subExpertiseName}}</div>
								</div>

								<div 
									class="items__item"
									v-bind:key="itemIndex"
									v-for="(itemObj, itemIndex) in subExpertise"
								>
									<v-checkbox 
										class="item__checkbox"
										v-if="!itemObj[3].custom"
										color="#4285F4"
										hide-details="true"
										:ripple="false"
										v-model="itemObj[2].enabled"
									></v-checkbox>

									<!-- -------------- -->
									<!--   REMOVE BTN   -->
									<!-- -------------- -->
									<v-btn 
										icon
										v-if="itemObj[3].custom"
										color="red"
										@click="removeSubExpertiseItem(subExpertise, itemIndex)"
										class="item__btn-remove add">
										<v-icon>mdi-close</v-icon>
									</v-btn>

									<Rating 
										class="item__rating"
										:class="{disabled: !itemObj[2].enabled}"
										v-model="itemObj[1].rate"
										:readonly.sync="itemObj[2].enabled"
										:length="5" />

									<div 
										:class="{disabled: !itemObj[2].enabled}"
										v-if="!itemObj[3].custom"
										class="item__text"
									>
										{{itemObj[0]}}
									</div>

									<!-- ---------------------- -->
									<!--   CUSTOM SKILL INPUT   -->
									<!-- ---------------------- -->
									<div 
										:class="{disabled: !itemObj[2].enabled}"
										v-if="itemObj[3].custom"
										class="item__text"
									>
										<v-text-field
											class="text__input"
											v-model="itemObj[0]"
											hide-details="true"
											label="name"
										></v-text-field>
									</div>
								</div>

								<div class="items__btn">

									<!-- -------------- -->
									<!--   ADD BUTTON   -->
									<!-- -------------- -->
									<v-btn 
										depressed 
										small
										@click="addSubExpertiseItem(subExpertise)"
										class="body__remove-btn blue add">
										Add
									</v-btn>
								</div>

							</div>
						</div>
					</div>
				</div>


				<!-- -------- -->
				<!--          -->
				<!--   WORK   -->
				<!--          -->
				<!-- -------- -->
				<div 
					class="block-2__level-1 work"
					v-if="activeFromTab == 'work'"
				>
					<div
						class="level-1__level-2"
						v-bind:key="workIndex"
						v-for="(work, workIndex) in profile['work']"
					>
						<div class="level-2__overlay"></div>

						<div class="level-2__order-btns">

							<v-btn 
								v-if="ifMoveUp(workIndex)"
								depressed 
								small
								@click="moveArrElement(profile['work'], workIndex, (workIndex-1))"
								class="btns__btn up"
							>
								<v-icon right dark>mdi-chevron-up</v-icon>
							</v-btn>

							<v-btn 
								v-if="ifMoveDown(profile['work'], workIndex)"
								depressed 
								small
								@click="moveArrElement(profile['work'], workIndex, (workIndex+1))"
								class="btns__btn down"
							>
								<v-icon right dark>mdi-chevron-down</v-icon>
							</v-btn>

							<v-btn 
								depressed 
								small
								@click="removeArrElement(profile['work'], workIndex)"
								class="btns__btn close"
							>
								<v-icon right dark>mdi-close</v-icon>
							</v-btn>
						</div>

						<div class="level-2__row shifted-left">
							<v-text-field
								class="row__from-date"
								v-model="work.period.from"
								label="From"
							></v-text-field>

							<v-text-field
								class="row__to-date"
								v-model="work.period.to"
								label="To"
							></v-text-field>

							<v-text-field
								class="row__company"
								v-model="work.company"
								label="Company"
							></v-text-field>
						</div>

						<v-text-field
							class="level-2__position"
							v-model="work.position"
							label="Position"
						></v-text-field>

						<v-text-field
							class="level-2__project-name"
							v-model="work['project_name']"
							label="Project Name"
						></v-text-field>

						<v-textarea
							class="level-2__project-descr"
							label="Project Description"
							rows="3"
							v-model="work['project_description']"
						></v-textarea>

						<div>
							<div
								class="level-2__level-3"
								v-bind:key="expertiseName"
								v-for="(subExpertises, expertiseName) in work['expertise']"
							>
								<div class="level-3__row">
									<div class="row__subtitle iomico-style-lable">
										{{expertiseName}}
									</div>
								</div>

								<div 
									class="level-3__level-4"
									v-bind:key="subExpertiseIndex"
									v-for="(subExpertise, subExpertiseIndex) in subExpertises"
								>
									<div class="level-4__items">
										<div class="items__label">

											<v-checkbox 
												class="label__checkbox"
												color="#4285F4"
												hide-details="true"
												:ripple="false"

												v-model="subExpertise[2].enabled"
											></v-checkbox>

											<div class="items__label">{{subExpertise[0]}}</div>

										</div>
									</div>
									<div class="level-4__list" v-if="subExpertise[2].enabled">
										<v-combobox
											v-model="subExpertise[1]"
											chips
											clearable
											multiple
										>
											<template v-slot:selection="{ attrs, item, select, selected }">
												<v-chip
													close
													small
													label

													v-bind="attrs"
													:input-value="selected"

													@click="select"
													@click:close="removeWorkSubExpertiseItem(subExpertise[1], item)"
												>
													<strong>{{ item }}</strong>
												</v-chip>
											</template>
										</v-combobox>
									</div>
								</div>

							</div>
						</div>
					</div>

					<div class="block-2__add-btn">
						<v-btn 
							depressed 
							@click="addWork(profile['work'])"
							class="blue add">
							Add
						</v-btn>
					</div>
				</div>

				<!-- ------------- -->
				<!--               -->
				<!--   EDUCATION   -->
				<!--               -->
				<!-- ------------- -->
				<div 
					class="block-2__level-1 education"
					v-if="activeFromTab == 'education'"
				>
					<div
						class="level-1__level-2"
						v-bind:key="schoolIndex"
						v-for="(school, schoolIndex) in profile['education']"
					>
						<div class="level-2__order-btns">

							<v-btn 
								v-if="ifMoveUp(schoolIndex)"
								depressed 
								small
								@click="moveArrElement(profile['education'], schoolIndex, (schoolIndex-1))"
								class="btns__btn up"
							>
								<v-icon right dark>mdi-chevron-up</v-icon>
							</v-btn>

							<v-btn 
								v-if="ifMoveDown(profile['education'], schoolIndex)"
								depressed 
								small
								@click="moveArrElement(profile['education'], schoolIndex, (schoolIndex+1))"
								class="btns__btn down"
							>
								<v-icon right dark>mdi-chevron-down</v-icon>
							</v-btn>

							<v-btn 
								depressed 
								small
								@click="removeArrElement(profile['education'], schoolIndex)"
								class="btns__btn close"
							>
								<v-icon right dark>mdi-close</v-icon>
							</v-btn>

						</div>

						<div class="level-2__row">
							<v-text-field
								class="row__from-date"
								v-model="school['attended dates'].from"
								label="from"
							></v-text-field>

							<v-text-field
								class="row__to-date"
								v-model="school['attended dates'].to"
								label="to"
							></v-text-field>

							<v-text-field
								class="row__company shifted-left"
								v-model="school['school name']"
								label="name"
							></v-text-field>
						</div>

						<div class="level-2__row">
							<v-text-field
								class="row__country"
								v-model="school['location']['country']"
								label="country"
							></v-text-field>

							<v-text-field
								class="row__city"
								v-model="school['location']['city']"
								label="city"
							></v-text-field>
						</div>

						<v-text-field
							class="level-2__project-name"
							v-model="school['degree']"
							label="degree"
						></v-text-field>

						<v-text-field
							class="level-2__project-name"
							v-model="school['academic honor']"
							label="academic honor"
						></v-text-field>

						<v-text-field
							class="level-2__project-name"
							v-model="school['field of study']"
							label="field of study"
						></v-text-field>

						<v-combobox
							v-model="school['student activities']"
							label="other activities / awards / honors"
							chips
							clearable
							multiple
						>
							<template v-slot:selection="{ attrs, item, select, selected }">
								<v-chip
									close
									small
									label

									v-bind="attrs"
									:input-value="selected"

									@click="select"
									@click:close="removeStudentActivity(school['student activities'], item)"
								>
									<strong>{{ item }}</strong>
								</v-chip>
							</template>
						</v-combobox>
					</div>

					<div class="level-1__add-btn">

						<!-- -------------- -->
						<!--   ADD BUTTON   -->
						<!-- -------------- -->
						<v-btn 
							depressed 
							@click="addEducation(profile['education'])"
							class="blue add">
							Add
						</v-btn>
					</div>
				</div>

			</div>

		</v-form>
	</div>

</div>
</template>

<script>

// @ is an alias to /src
import Rating from '@/components/Rating.vue';

// import cvEmpty from '@/assets/data/cvEmpty.json';
// import VueUploadComponent from 'vue-upload-component'; 

export default {
	name: 'hrprofile',

	components: {
		Rating
		/* ,FileUpload: VueUploadComponent */
	},

	data: function(){
		return {
			profile: {}
			,loading: false
			,errored: false
			,languageLevels: [
				'A1 / Beginner'
				,'A2 / Elementary'
				,'B1 / Intermediate'
				,'B2 / Upper Intermediate'
				,'C1 / Advanced'
				,'C2 / Proficient'
			]
			,familyStatus: [
				'Single'
				,'Married'
			]
			,activeFromTab: 'expertise'
			,imageData: ''
		};
	}

	,computed: {
		getPictureUrl: function(){
			let path = 'http://iomico.co/images/';

			if(this.imageData){ 
				return this.imageData 
			} else{
				return path + (this.profile.picture || 'avatar__600x600.jpg');
			}
		}
	}

	,methods:{

		previewImage: function(event) {
			// Reference to the DOM input element
			var input = event.target;

			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {

				// create a new FileReader to read this image 
				// and convert to base64 format
				var reader = new FileReader();

				// Define a callback function to run, 
				//when FileReader finishes its job
				reader.onload = (e) => {

					// Note: arrow function used here, 
					// so that "this.imageData" refers to the imageData of Vue component
					// Read image as base64 and set to imageData
					this.imageData = e.target.result;
				}

				// Start the reader job - read file as a data url (base64 format)
				reader.readAsDataURL(input.files[0]);

				let profile_id = this.profile.profile_id;
				let url = `http://iomico.co/api/profiles/${profile_id}/avatar-upload`;

				var formData = new FormData();
				formData.append('file', input.files[0]);
				formData.append('name', profile_id);

				this.axios
					.post(
						url
						,formData
						,{ headers: { 'Content-Type': 'multipart/form-data' } }
					)
					.then(response => {
						this.responce = response;
						this.profile.picture = profile_id+".jpg";
					})
					.catch(error => {
						this.errored = true;
					})
					.finally(() => {
						this.loading = false;
						//this.$route.params.id
					});
			}
		}

		,addLanguage: function(languages){
			languages.push(
				{
					"name": ""
					,"total_level": ""
					,"levels": [
						["speak",{"rate": 5}]
						,["write",{"rate": 5}]
						,["listen",{"rate": 5}]
						,["read",{"rate": 5}]
					]
				}
			);
		}

		,ifMoveUp: function(elementIndex){
			return elementIndex > 0;
		}

		,ifMoveDown: function(arr, elementIndex){
			let returnVal = (elementIndex + 1) < arr.length
			return returnVal;
		}

		,moveArrElement: function(arr, position, newPosition){
			arr.splice(
				newPosition, 
				0, 
				arr.splice(position, 1)[0]
			);
		}

		,removeArrElement: function(works, workIndex){
			works.splice(workIndex, 1);
			works = [...works];
		}

		,removeHobby: function(list, item){
			list.splice(list.indexOf(item), 1);
			list = [...list];
		}

		,removeStudentActivity: function(list, item) {
			list.splice(list.indexOf(item), 1);
			list = [...list];
		}

		,updateChildren: function(familyStatus){
			if(familyStatus == 'Single') this.profile.children = 0;
		}

		,updateActiveFromTab: function(formTabName){
			this.activeFromTab = formTabName;
		}



		/*  -----------------  */
		/*  Expertise methods  */
		/*  -----------------  */
		,addSubExpertiseItem: function(subExpertise){
			subExpertise.push(
				["", {rate: 5}, {enabled: true}, {custom: true}]
			);
		}

		,removeSubExpertiseItem: function(subExpertise, itemIndex){
			subExpertise.splice(itemIndex, 1);
			subExpertise = [...subExpertise];
		}


		/*  ----  */
		/*  Work  */
		/*  ----  */
		// remove combobox chip
		,removeWorkSubExpertiseItem: function(subExpertise, item){
			subExpertise.splice(subExpertise.indexOf(item), 1);
			subExpertise = [...subExpertise];
		}

		,addWork: function(works){
			works.push(
				{
					"company": ""
					,"period": {
						"from": ""
						,"to": ""
					}
					,"position": ""
					,"project_name": ""
					,"project_description": ""
					,"tasks": []
					,"expertise": {
						"programming": [
							["language", [], {"enabled":false},{"custom": false}]
							,["database", [], {"enabled":false},{"custom": false}]
							,["network", [], {"enabled":false},{"custom": false}]
							,["library / framework / platform", [], {"enabled":false},{"custom": false}]
							,["technology", [], {"enabled":false},{"custom": false}]
							,["media", [], {"enabled":false},{"custom": false}]
							,["os", [], {"enabled":false},{"custom": false}]
							,["virtualization", [], {"enabled":false},{"custom": false}]
							,["tool", [], {"enabled":false},{"custom": false}]
							,["other", [], {"enabled":false},{"custom": false}]
						]
						,"electronics": [
							["peripherals", [], {"enabled":false},{"custom": false}]
							,["network", [], {"enabled":false},{"custom": false}]
							,["mcu", [], {"enabled":false},{"custom": false}]
							,["cpu", [], {"enabled":false},{"custom": false}]
							,["gpu", [], {"enabled":false},{"custom": false}]
							,["fpga", [], {"enabled":false},{"custom": false}]
							,["power management", [], {"enabled":false},{"custom": false}]
							,["sensor", [], {"enabled":false},{"custom": false}]
							,["other", [], {"enabled":false},{"custom": false}]
						]
						,"industrial design": [
							["tool", [], {"enabled":false},{"custom": false}]
							,["device / machine", [], {"enabled":false},{"custom": false}]
						]
					}
				}

			);
		}

		/*  ---------  */
		/*  Education  */
		/*  ---------  */
		,addEducation: function(educations){
			educations.push(
				{
					"school name": ""
					,"location": {
						"country": ""
						,"city":""
					}
					,"attended dates": {
						"from": ""
						,"to": ""
					}
					,"degree": ""
					,"academic honor": ""
					,"field of study": ""
					,"student activities": []
				}
			);
		}
		,saveProfile: function(profile){
		
			this.loading = true;

			var id = this.profile.profile_id;
			var url = `http://iomico.co/api/profiles/${id}/save/`;

			// save profile
			this.axios
				.post(
					url
					,{body: this.profile}
				)
				.then(response => {
					this.responce = response;
					this.$router.push({ name: 'hr' });
				})
				.catch(error => {
					this.errored = true;
				})
				.finally(() => {
					this.loading = false;
					//this.$route.params.id
				});
		}
		,deleteProfile: function(id){

			var url = `http://iomico.co/api/profiles/${id}/delete/`;
			this.axios
				.get(url)
				.then(response => {
					this.responce = response;
					this.$router.push({ name: 'hr' });
				})
				.catch(error => {
					this.errored = true;
				})
				.finally(() => {
					this.loading = false;
					//this.$route.params.id
				});
			
		}
	}

	,created(){

		var id = this.$route.params.id;
		var url = `http://iomico.co/api/profiles/${id}/`;

		this.axios
			.get(url)
			.then(response => {

				if( !('about' in response.data[0]) ){
					response.data[0].about = '';
				}

				this.profile = response.data[0];
			})
			.catch(error => {
				this.errored = true;
			})
			.finally(() => {
				this.loading = false;
			})

	}

	,mounted(){
	}

}
</script>
